module.exports = __webpack_public_path__ + "img/dwarf_26.afe5b16d.png";